import Vue from "vue";
import Router from "vue-router";
import Index from "./views/index.vue";
import { cancelRequests } from "@/api/lib";
Vue.use(Router);

let router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      redirect: "/homeTrainingCenter",
      meta: {
        title: "甬企课堂",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/homeTrainingCenter",
      name: "homeTrainingCenter",
      component: (resolve) =>
        require(["@/views/homeTrainingCenter/homeTrainingCenter.vue"], resolve),
      meta: {
        title: "甬企课堂",
        keepAlive: true, //需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.name === "homeTrainingCenter") {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  cancelRequests(); // 终止进行中的请求
  next();
});
router.afterEach(() => {
  // 在每次路由跳转后执行滚动到顶部的操作
  window.scrollTo(0, 0);
});

export default router;
